
import {Modal} from "react-bootstrap";
import {useIntl} from "react-intl";
import React, {useCallback, useEffect, useRef, useState} from "react";
import './modals.scss';
import '../../Steps/RequestInfo/request-info.scss';
import {AdminService, AuthService, WLOCreditAPIService} from "../../../services";
import {Check} from "@mui/icons-material";
import {AppRoutes} from "../../../Router";
import {useNavigate} from "react-router-dom";
import { useSignContext } from "../../../hooks/useSignContext";
import { useRequestContext } from "../../../hooks/useRequestContext";
import {typeIdentification} from "../../../__mocks__/data"
import Moment from 'moment';
import { WloCreditoService } from "../../../types";
interface EnterCodeProps {
    token: string;
    show: boolean;
    onHide: () => void;
    sendCode: () => void;
    errors?: any;
    values?: any;
}

export function EnterCode(props: EnterCodeProps) {
    const {sign, setSign} = useSignContext();
    const {request, setRequest} = useRequestContext();
    const navigate = useNavigate();
    const {onHide, show, token, sendCode} = props;
    const [counter, setCounter] = useState(300);
    const timeOutCallback = useCallback(() => setCounter(currTimer => currTimer - 1), []);
    useEffect(() => {
        if(show){
            counter > 0 && setTimeout(timeOutCallback, 1000);
        }
      }, [counter, timeOutCallback,show]);
    const intl = useIntl();
    const defaultCode = new Array(6).fill('');
    const [modalShow, setModalShow] = React.useState(false);
    const [isSucessful, setIsSucessful] = React.useState(false);
    const [errorCode, setErrorCode] = useState<boolean>(false);
    const [viewNewCode, setViewNewCode] = useState<boolean>(false);
    const [code, setCode] = useState<string[]>(defaultCode);
    const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
    const [codigoClie, setCodigo] = useState("");
    const resetCode = () => {
        setCounter(300)
        setCode(defaultCode);
        onHide()
    }

    const handleSearchSagrilaft = async () => {
        onHide();
    }
    const verifyGas= async ()=> {
        let tipodocumento='';
        let valorpuntajeEntre0y150=false
        let presentaRiesgos=false
        let puntaje=0
        let cuotaData = 0
        let scorepuntaje=0
        let ingresoValidado=false
        let scorecygnus=false
        let enestudio=false
        let negado=false
        let valorDataCreditoCodeudor=false
        let documentRequest;
        let sagrilaftRiesgo
        let responseData
        if(sign.typeIdentification==="4")tipodocumento="ti"
        if(sign.typeIdentification==="1")tipodocumento="cc"
        if(sign.typeIdentification==="3")tipodocumento="ce"
        if(sign.typeIdentification==="2")tipodocumento="nit"
        if(sign.typeIdentification==="5")tipodocumento="pa"
            //consulta Estado entidad Tercero 
            const estadoTerce = await AdminService.entidadTer("");
            if(estadoTerce.payload){

                //consulta sagrilaft
                // const data = {
                //     datoConsultar: Number(sign.numIdentification!), //19123402
                //     tipoDocumento: tipodocumento,
                //     numeroSolicitud: Number(request.numSol!), //No tenemos un ws que nos diga el nro de solicitud
                //     fechaSolicitud: Moment(new Date()).format('MM/DD/YYYY'),
                //     email: `${sign.email!}`
                // }

                //Consulta Terceros
                if(estadoTerce.payload.data.ListRef.Datos_Referencias[1].s_descripcion_legal == "1"){
                    // const response = await WLOCreditAPIService.consultaConsolidada(data);
                    // if(response.payload.presentaRiesgo){
                    //     sagrilaftRiesgo = "1"
                    //     presentaRiesgos=true
                    // }else{
                    //     sagrilaftRiesgo = "0"
                    //     presentaRiesgos=false
                    // }
                    
                //consulta datacredito
                let consulta
                if(request.personCygnus?.Pws_Apellidos1 =="" ||request.personCygnus?.Pws_Apellidos1 !="" ){
                    let sends:WloCreditoService.SolicitudDetalla={
                        Pws_Num_Solicitud:request.numSol!,
                        Pws_Identificacion:sign.numIdentification!,
                        Pws_Tip_Identificacion:String(typeIdentification.WS_TIPOS_IDENTIFICACION_IResult.LstTiposIdent.Datos_TiposIdentificacion.filter(valor=>valor.s_codigo==Number(sign.typeIdentification!))[0].s_datacredito),
                        Pws_Perfil_Acceso:"",
                        Pws_Fec_Solicitud:"",
                    }
                    consulta = await WLOCreditAPIService.consultaSolicitudCygnusDetal(sends)
                }
                let apellido
                if(request.personCygnus?.Pws_Apellidos1 ==""){
                    apellido =consulta.payload.data.datos_persona.Datos_persona[0].Pws_Apellidos1
                }else{
                    apellido = request.personCygnus?.Pws_Apellidos1
                }
                const dataHistoriaCredit: WloCreditoService.HistoriaCreditoRequest = {
                    personIdNumber: sign.numIdentification!,
                    personIdType: Number(sign.typeIdentification)!,
                    personLastName: apellido,
                }

                const dataValorIngreso: WloCreditoService.ValorIngresoRequest = {
                    identificacionBuscar: sign.numIdentification!,
                    ingresoValidar: 1500000!,
                    tipoIdBuscar: Number(sign.typeIdentification)!,
                }

                const responseHistoriaCredito = await WLOCreditAPIService.historiaCreditoRemote(dataHistoriaCredit);

                const responseValorIngreso = await WLOCreditAPIService.valorIngresoRemote(dataValorIngreso);
                
                if (responseHistoriaCredito?.responseData) {
                    if (responseHistoriaCredito.responseData.Fault) {
                        puntaje = 0;
                    } else {
                        puntaje = Number(responseHistoriaCredito.responseData.ReportHDCplus?.models?.[0]?.scoreValue || 0);
                        const liabilities =
                            responseHistoriaCredito.responseData.ReportHDCplus?.liabilities ?? [];
                        cuotaData = liabilities.reduce(
                            (
                                sum: number,
                                liability: {values?: Array<{valueMonthlyPayment?: unknown}>}
                            ) =>
                                sum +
                                (liability.values ?? []).reduce(
                                    (s: number, v: {valueMonthlyPayment?: unknown}) =>
                                        s + Number(v?.valueMonthlyPayment || 0),
                                    0
                                ),
                            0
                        );
                    }
                }
                const resultConsultaPersona = await WLOCreditAPIService.consultaSolicitudCygnus({
                    Pws_Identificacion: sign.numIdentification,
                    Pws_Tip_Identificacion: sign.typeIdentification!,
                });
                
                try {
                    let valIngreso = responseValorIngreso.responseData.resumen_general_ingresos.promedio_ingresos_cotizante;

                    const quantoLista = responseHistoriaCredito.responseData.ReportHDCplus.productValueList[0];

                    let quantoNoCero = [];

                    for (let i = 0; i < quantoLista.length; i++) {
                        if (quantoLista[i].value !== 0) {
                            quantoNoCero.push(quantoLista[i].value);
                        }
                    }

                    let quantoMinimo = Math.min.apply(null, quantoNoCero);
                    let cuantoMin = quantoMinimo;

                    if (valIngreso !== null && valIngreso !== '0') {
                        resultConsultaPersona.payload.data.datos_operfinan.Datos_operfinan[0].Pws_Ingreso_Principal =
                            valIngreso;
                        resultConsultaPersona.payload.data.datos_operfinan.Datos_operfinan[0].Pws_otros_ingresos = 0;
                        ingresoValidado=true
                    } else if (cuantoMin !== null && cuantoMin !== 0) {
                        resultConsultaPersona.payload.data.datos_operfinan.Datos_operfinan[0].Pws_Ingreso_Principal =
                            cuantoMin;
                        resultConsultaPersona.payload.data.datos_operfinan.Datos_operfinan[0].Pws_otros_ingresos = 0;
                        ingresoValidado=true
                    } else {
                        ingresoValidado=false
                    }
                    let ingresos = resultConsultaPersona.payload.data.datos_operfinan.Datos_operfinan[0];
                    const operFinancieras = {
                        s_num_solicitud: request.numSol!,
                        s_identificacion: sign.numIdentification!,
                        s_tipo_identificacion: sign.typeIdentification,
                        s_ingreso_principal: ingresos.Pws_Ingreso_Principal,
                        s_otros_ingresos: ingresos.Pws_otros_ingresos,
                        s_otros_egresos: ingresos.Pws_Otros_egresos,
                        s_arriendo: ingresos.Pws_Arriendo,
                        s_concep_otr_ingre: ingresos.Pws_Concep_otr_ingre,
                        s_declarante_ren: ingresos.Pws_Declarante_ren,
                        s_moneda_ext: ingresos.Pws_Moneda_ext,
                        s_monext_oper: ingresos.Pws_Monext_oper,
                        s_tip_monext: ingresos.Pws_Tip_monext,
                        s_cuent_ext: ingresos.Pws_Cuent_ext,
                        s_cuen_extban: ingresos.Pws_Cuen_extban,
                        s_cuen_extnum: ingresos.Pws_Cuen_extnum,
                        s_cuen_extpais: ingresos.Pws_Cuen_extpais,
                        s_cuen_extciudad: ingresos.Pws_Cuen_extciudad,
                    };
                    const valorfinancial = await WLOCreditAPIService.addFinancialInformation(operFinancieras);
                    const tipPerfilCygnus =
                        resultConsultaPersona.payload.data.datos_persona?.Datos_persona?.[0]?.Pws_Tip_Perfil ??
                        request.personCygnus?.Pws_Tip_Perfil ??
                        '2';
                    await WLOCreditAPIService.grabar_cignus({
                        Pws_Identificacion: sign.numIdentification!,
                        Pws_Tip_Identificacion: String(sign.typeIdentification!),
                        Pws_Tip_Perfil: String(tipPerfilCygnus || '2'),
                    });
                } catch (e) {}
            
                //Guardar Data credito
                let estadoDatacredito = "0"
                if(puntaje>=1 && puntaje<600){
                    estadoDatacredito = "1"
                }else if(puntaje>=600){
                    estadoDatacredito = "0"
                }
                //SUMA DEL RESPONSE JSON
                const combinadoJson = JSON.stringify({
                    responseHistoriaCredito,
                    responseValorIngreso,
                });

                // JSON A XML
                const escapeXml = (unsafe: any): string => {
                    if (unsafe === null || unsafe === undefined) return '';
                    return String(unsafe)
                        .replace(/&/g, '&amp;')
                        .replace(/</g, '&lt;')
                        .replace(/>/g, '&gt;')
                        .replace(/"/g, '&quot;')
                        .replace(/'/g, '&apos;');
                };

                const jsonToXml = (obj: any, rootName: string = 'root'): string => {
                    let xml = `<${rootName}>`;
                    if (Array.isArray(obj)) {
                        obj.forEach((item) => {
                            xml += jsonToXml(item, 'item');
                        });
                    } else if (typeof obj === 'object' && obj !== null) {
                        for (const prop in obj) {
                            if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;
                            const value = obj[prop];
                            if (Array.isArray(value)) {
                                value.forEach((item) => {
                                    xml += jsonToXml(item, prop);
                                });
                            } else if (typeof value === 'object' && value !== null) {
                                xml += jsonToXml(value, prop);
                            } else {
                                xml += `<${prop}>${escapeXml(value ?? '')}</${prop}>`;
                            }
                        }
                    } else {
                        xml += escapeXml(obj ?? '');
                    }
                    xml += `</${rootName}>`;
                    return xml;
                };

                const parsedJson = JSON.parse(combinadoJson);
                const xmlFinal = jsonToXml(parsedJson, 'dataCredito');
                // console.log('XML FINAL', xmlFinal);

                //Guardar Datacredito
                const data5 = {
                    Pws_num_solicitud : request.numSol!,
                    Pws_Identificacion : sign.numIdentification!,
                    Pws_Tip_Identificacion: sign.typeIdentification!,
                    Pws_Fec_gen:  Moment(new Date()).format('MM/DD/YYYY'),
                    Pws_estado_resotp:estadoDatacredito,
                    Pws_Tip_val: '2', 
                    Pws_Puntaje: String(puntaje),
                    Pws_Entidad_Consul: '4', 
                    Pws_Num_cuodat: String(cuotaData),
                    Pws_Xml_Dc: xmlFinal,
                }
                if(estadoTerce.payload.data.ListRef.Datos_Referencias[2].s_descripcion_legal == "1"){
                    const response5 = await WLOCreditAPIService.regDataCreditoAndSagrilaft(data5);
                }
                //evualua score cygnus
                if(Number(request.valoresLogin.tipodeudor)<2){
                    const response10 = await WLOCreditAPIService.EvaluaScore({
                        ps_radicado:request.valoresLogin.radicado,
                        ps_identificacion:String(sign.numIdentification),
                        ps_cod_lin:request.valoresLogin.lineacredito,
                        ps_tipoCliente:request.valoresLogin.tipocliente==""?"2": request.valoresLogin.tipocliente,
                        ps_tip_deucode:request.valoresLogin.tipodeudor    
                    })
                    scorepuntaje=response10.payload.data.puntaje_obtenido
                    // const  consultaCupo= await WLOCreditAPIService.consultaCupo({
                    //     Pws_Solicitud: String(localStorage.getItem("num_solicitud")),
                    //     Pws_Identificacion: String(sign.numIdentification),
                    //     Pws_num_Tip_Ident: String(sign.typeIdentification!),
                    // })
                    // localStorage.setItem('cupoRotativo', consultaCupo.payload.data.Cupo);
                }else{
                //Si tipodeudor es mayor a 2 es porque es codeudor propietario, no valida score cygnus
                    scorepuntaje=0
                    scorecygnus=true
                }

            //Guarda Sagrilaft
            // if(estadoTerce.payload.data.ListRef.Datos_Referencias[1].s_descripcion_legal == "1"){
            //     const response2 = await WLOCreditAPIService.regDataCreditoAndSagrilaft( {
            //         Pws_num_solicitud : request.numSol!,
            //         Pws_Identificacion : sign.numIdentification!,
            //         Pws_Tip_Identificacion:sign.typeIdentification!,
            //         Pws_Fec_gen: Moment(new Date()).format('MM/DD/YYYY'),
            //         Pws_estado_resotp: sagrilaftRiesgo,
            //         Pws_Tip_val: '1',
            //         Pws_Puntaje: '0',
            //         Pws_Entidad_Consul: '2',
            //         Pws_Num_cuodat: '',
            //     });
            // }
                
                //Gurada Score Cygnus
                let estadocygnus = "0"
                if(scorepuntaje >=51){
                    estadocygnus = "0"
                }else{
                    estadocygnus = "1"
                }
                const data6 = {
                    Pws_num_solicitud : request.numSol!,
                    Pws_Identificacion : sign.numIdentification!,
                    Pws_Tip_Identificacion: sign.typeIdentification!,
                    Pws_Fec_gen:  Moment(new Date()).format('MM/DD/YYYY'),
                    Pws_estado_resotp: estadocygnus,
                    Pws_Tip_val: '4',
                    Pws_Puntaje: String(scorepuntaje),
                    Pws_Entidad_Consul: '5',
                    Pws_Num_cuodat: '',
                    Pws_Xml_Dc: '',
                }
                if(estadoTerce.payload.data.ListRef.Datos_Referencias[4].s_descripcion_legal == "1"){
                    const response6 = await WLOCreditAPIService.regDataCreditoAndSagrilaft(data6);
                }
                //Listas restrictivas API
                if (sign.typeIdentification==="1"){
                    const listasR={
                    people: [
                                {
                                name: (consulta.payload.data.datos_persona.Datos_persona[0].Pws_Nombres +" " +consulta.payload.data.datos_persona.Datos_persona[0].Pws_Apellidos1 + " " +consulta.payload.data.datos_persona.Datos_persona[0].Pws_Apellidos2 ),
                                doc_id: sign.numIdentification!,
                                tipo_doc: "CC"
                                }
                        ]
                    };
                try {
                    const listas = await WLOCreditAPIService.getListasRestrictivas(listasR);
                    const documentRequest= {
                        Pws_num_solicitud: request.numSol!,
                        Pws_Identificacion: sign.numIdentification!,
                        Pws_Tip_Identificacion: sign.typeIdentification!,
                        Pws_Doc_Tipo: "5",
                        Pws_Doc_nombre: 'Listas restrictivas.pdf',
                        Pws_Doc_estado: "1",
                        Pws_Doc_ruta: "1",
                        Pws_Clave_doc: listas.payload,
                    };
                    const solicitud = await WLOCreditAPIService.addDocuments(documentRequest);
                } catch (error) {
                    console.log("E-LR");;
                }
                }

                //Guardar documento Sagrilaft
                // const downloadDocument= await AuthService.documentSagrilaft({idDatoConsultado:response.payload.idDatoConsultado})
                // documentRequest= {
                //     Pws_num_solicitud: request.numSol!,
                //     Pws_Identificacion: sign.numIdentification!,
                //     Pws_Tip_Identificacion: sign.typeIdentification!,
                //     Pws_Doc_Tipo: "4",
                //     Pws_Doc_nombre:response.payload.idDatoConsultado+".pdf" ,
                //     Pws_Doc_estado: "1",
                //     Pws_Doc_ruta: "1",
                //     Pws_Clave_doc:"data:application/pdf;base64,"+downloadDocument.payload,
                // };


            }

            // const solicitud = await WLOCreditAPIService.addDocuments(documentRequest);
            // console.log(solicitud)
            //codeudor o el cliente
            if(Number(request.valoresLogin.tipodeudor)<2){
                const solicitudResulado = await WLOCreditAPIService.addSolicitud({
                    Pws_num_solicitud:request.numSol!,
                    Pws_Identificacion:sign.numIdentification!,
                    Pws_Tip_Identificacion: sign.typeIdentification!
                });
               
                
                //NEGADO
                if( (puntaje>=1 && puntaje <=49) || (scorepuntaje <50) ){
                    presentaRiesgos=false
                    valorDataCreditoCodeudor=false
                    negado=true
                    enestudio=false
                    solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado="5"
                }
                //APROBADO
                // if((puntaje >600) && (sagrilaftRiesgo='0') && (scorepuntaje >60)){
                
                ////Si puntaje es mayor a 600, score puntaje es mayor a 60 y ingreso validado es true, entonces aprobado
                else if((puntaje >= 600) && (scorepuntaje >= 60) && (ingresoValidado)){
                    presentaRiesgos=false
                    valorDataCreditoCodeudor=false
                    negado=false
                    enestudio=false
                    solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado="4"      
                }
                ////Si puntaje es menor a 600, score puntaje es menor a 60 o ingreso validado es false, entonces en estudio
                //EN ESTUDIO
                else{
                    presentaRiesgos = false;
                    valorDataCreditoCodeudor=false
                    negado=false
                    enestudio=true
                    solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado="12"   
                }         
             
                //Codeudor Requerido
                // else if((puntaje>=150 && puntaje <=500) || (scorepuntaje >=51 && scorepuntaje <=60) && (sagrilaftRiesgo='0') ){
                //     presentaRiesgos=false
                //     valorDataCreditoCodeudor=true
                //     negado=false
                //     enestudio=false
                //     solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado="7"
                // }
                
                    
                const solicitudResulados = await WLOCreditAPIService.addSolicitud(solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0])

            // }else{
            //   let valueTipo=""
            //   let dataCodeudor=request.valoresLogin.radicado
            //    // if(!negado && !presentaRiesgos && !valorDataCreditoCodeudor && puntaje>500){
            //       if( !presentaRiesgos  && puntaje>500 && scorepuntaje >60){
            //         valueTipo="4"
            //         enestudio=false
            //         //cambio de estado a aprobado por el codeudor
            //         const solicitudResulado = await WLOCreditAPIService.addSolicitud({
            //             Pws_num_solicitud:request.numSol!,
            //             Pws_Identificacion:dataCodeudor.Pws_Identificacion!,
            //             Pws_Tip_Identificacion: dataCodeudor.Pws_Tip_Identificacion!
            //         });
            //         solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0].Pws_Tip_Estado="4"
            //         const solicitudResulados = await WLOCreditAPIService.addSolicitud(solicitudResulado.payload.data.Datos_Sol.Datos_Sol[0])
            //         envioCupo()
            //     }else if(negado){
            //         valueTipo="5"
            //     }else{
            //         valueTipo="5"
            //     }
            //     dataCodeudor.Pws_Estado=valueTipo
            //     const solicitudResulado = await WLOCreditAPIService.addCodeudor(dataCodeudor)
            const datasEstudio={
                id:"hola",
                number:request.numSol!,
                email:sign.email!,
                typeIdent:sign.typeIdentification!,
                numbIdent:sign.numIdentification!,
                Negado:negado,
              }
              const datasAprobadoRechazado={
                solicitud:request.numSol!,
                email:sign.email!,
                dateSolicitud:Moment(new Date()).format('DD/MM/YYYY'),
                respuesta:!negado,
            
              }
              if(enestudio){
                const response = await WLOCreditAPIService.getEmail(datasEstudio);
              }else{
                const response = await WLOCreditAPIService.confirmacionEmail(datasAprobadoRechazado);
              }
            }
         navigate(AppRoutes.VIEW_DOCUMENT_SIGN+"?"+(presentaRiesgos?"1":"0")+"-"+(negado?"1":"0")+"-"+(valorDataCreditoCodeudor?"1":"0")+"-"+(enestudio?"1":"0"), {replace: true});
        }
    }
    //guarda el cupo
    // const envioCupo= async()=>{
    //     let lineas;
    //     const valor= await AdminService.getlineascredito();
    //     lineas = valor.payload.data.ListLineaCredito.Datos_LineasCredito.length;
    //     let nume = 0
    //     let cupoRot;
    //     let codigo= 0;
    //     let result;
    //     let fecha_inicia
        
    //     let valoragregado={
    //       Pws_num_solicitud: request.numSol!,
    //       Pws_fec_solicitud_ini:"",
    //       Pws_fec_solicitud_fin:"",
    //       Pws_Tip_estado: "",
    //       Pws_Tip_Consulta: "1"
    //     }

    //     const consultaSolicitud = await WLOCreditAPIService.consultaSolicitudListadoCygnus(valoragregado)
    //     //.then((data) => {
    //     //  fecha_inicia = data.payload.data.datos_soli.datos_Sol[0].Pws_fec_solicitud;
    //     //  result = data.payload.data.datos_soli.datos_Sol[0].Pws_Lincre
    //     //});


        // while (nume < lineas){
        //     if(valor.payload.data.ListLineaCredito.Datos_LineasCredito[nume].s_nombre == result){
        //       cupoRot = valor.payload.data.ListLineaCredito.Datos_LineasCredito[nume].s_rotativo
        //       codigo = valor.payload.data.ListLineaCredito.Datos_LineasCredito[nume].s_codigo
        //       setCodigo(valor.payload.data.ListLineaCredito.Datos_LineasCredito[nume].s_codigo)
        //     }
        //   nume+=1
        // }
    //     const cupo = String(localStorage.getItem('cupoRotativo'))
    //     var d = new Date,
    //       dformat = [d.getMonth()+1,
    //                 d.getDate(),
    //                 d.getFullYear()].join('/');
    //     const creaCupo={
    //       s_r_ident_cliente: String(sign.numIdentification),
    //       s_r_lin_cred: String(codigo),
    //       s_r_fec_ini_cupo: String(dformat),
    //       s_r_fec_fin_cupo: String(dformat),
    //       s_r_monto_cupo: String(cupo)
    //     }
    //     const responde  = await WLOCreditAPIService.registraCupo(creaCupo)
    // }

    const setCodeValue = (event: any, position: number) => {
        const {target} = event;
        const value = target.value.trim();
        if (isNaN(value) || value.length > 1) return;
        if (errorCode) setErrorCode(false);
        const newCode = JSON.parse(JSON.stringify(code));
        newCode[position] = value;
        setCode(newCode);
        if (value && inputRefs.current[position + 1]) {
            inputRefs.current[position + 1]?.focus();
        }
    }

    const clickVerifyCode = async () => {
        try {
            const codeStringValue = code.join('');
            if (codeStringValue.length < 6) return;
            const data = {
                codes: codeStringValue,
                token,
                identificacion: sign.numIdentification,
                tipoIdentificacion: sign.typeIdentification
            };
            const response = await WLOCreditAPIService.verifyCodeRegOtp(data);
            const hasErrors = response?.errors && (response.errors === true || response.errors?.invalidCode || response.errors?.invalidToken);
            if (hasErrors) {
                setSign({...sign, signValidated: false});
                setErrorCode(true);
                return;
            }
            let signedPdf: string | null = null;
            try {
                signedPdf = await persistSignedAuthorizationDocument(codeStringValue);
            } catch (err) {
                console.error('Error guardando documento firmado:', err);
            }
            setSign({
                ...sign,
                signValidated: true,
                otp: codeStringValue,
                ...(signedPdf ? { signedDocumentDataUrl: signedPdf } : {}),
            });
            setErrorCode(false);
            setIsSucessful(true);
            verifyGas();
        } catch (error: any) {
            const { errors } = error;
            setSign({...sign, signValidated: false});
            setErrorCode(true);
        }
    }

    const sendNewCode = () => {
        sendCode();
        setErrorCode(false);
        setViewNewCode(true);
        setCounter(300)
    }

    const viewInputEnterCode = () => {
        setCode(defaultCode);
        setViewNewCode(false);
    }
    const handleKeyUp = (event:any, index:number) => {
        if (event.key === "Backspace" && !code[index] && inputRefs.current[index - 1]) {
            inputRefs.current[index - 1]?.focus();
        }
    }

    /** Mismo flujo que carga de documentos del cliente: PDF firmado (data URL) vía `addDocuments`. */
    const persistSignedAuthorizationDocument = async (otpCode: string): Promise<string | null> => {
        const docNumSol = request.numSol;
        const docIdent = request.personCygnus?.Pws_Identificacion ?? sign.numIdentification;
        const docTipoRaw = request.personCygnus?.Pws_Tip_Identificacion ?? sign.typeIdentification;
        const docTipoIdent = docTipoRaw != null ? String(docTipoRaw) : '';
        if (!docNumSol || !docIdent || !docTipoIdent) return null;
        const valor = await WLOCreditAPIService.getDocumento({
            Pws_num_solicitud: docNumSol,
            Pws_Identificacion: docIdent,
            Pws_Tip_Identificacion: docTipoIdent,
            otp: otpCode,
        });
        const payload = valor?.payload;
        if (!payload || typeof payload !== 'string') return null;
        const documentRequest: WloCreditoService.DocumentosRequest = {
            Pws_num_solicitud: docNumSol,
            Pws_Identificacion: docIdent,
            Pws_Tip_Identificacion: docTipoIdent,
            Pws_Doc_Tipo: "12",
            Pws_Doc_nombre: "Documento_Firmado.pdf",
            Pws_Doc_estado: "1",
            Pws_Doc_ruta: "1",
            Pws_Clave_doc: payload,
        };
        await WLOCreditAPIService.addDocuments(documentRequest);
        return payload;
    };
    const renderInputEnterCode = () => {
        return (
            <>
            <div>
                <h3 className="sub-title">
                    <p>Al ingresar el código, aceptas ser consultado en listas restrictivas y sagrilaft.</p>
                    <p>Por favor inserta aquí:</p>
                </h3>
                <div className="flex-container-modals p-0 m-0">
                    {code.map((value: string, index: number) => {
                        return <div key={index}>
                            <input
                                   ref={(el) => (inputRefs.current[index] = el)}
                                   value={value}
                                   className={"input-code-general"}
                                   type="text"
                                   inputMode="numeric"
                                   maxLength={1}
                                   onChange={event => setCodeValue(event, index)}  
                                   onKeyUp={event =>handleKeyUp(event, index)}/>
                        </div>
                    })}
                </div>
                <h3 className="sub-title">
                    <p>Falta {counter} seg para poder envia de nuevo el codigo</p>
                </h3>
                <br/>
                {counter>0?<>
                    <div className="button-center">
                    <div className="form-know-you-item-button button-red color-red"
                         onClick={clickVerifyCode}>Continuar
                    </div>
                </div>
                </>:<>
                <div className="button-center">
                    <div className="form-know-you-item-button button-red color-red"
                         onClick={sendNewCode}>Pedir Codigo
                    </div>
                </div>
                </>}
               
            </div>
            </>
            
        )
    }

    const renderErrorCodeBanner = () => {
        return (
            <div className="mb-3">
                <h3 className="sub-title color-red">Has ingresado un código incorrecto o tu tiempo para ingresarlo ha caducado.</h3>
                <br/>
            </div>
        )
    }

    const renderNewCode = () => {
        return (
            <div>
                <h3 className="sub-title color-green">Se ha enviado un nuevó código revisa tu correo o celular
                    registrado</h3>
                <br/>
                <div className="button-center">
                    <div className="form-know-you-item-button button-green color-green"
                         onClick={viewInputEnterCode}>Aceptar
                    </div>
                </div>
            </div>
        )
    }

    const renderFirmaCorrecta = () => {
        return (
            <div>
                <div className="row">
                    <Check/>
                </div>
                <br/>
                <h3 className="sub-title color-green">Has firmado correctamente para la autorización de los datos.
                    Espera un momento...</h3>
                <br/>
                <h1 className="sub-title color-green" style={{ textAlign:'center'}}  >NO CERRAR</h1>
                {/* <div className="button-center">
                    <div className="form-know-you-item-button button-red color-red"
                         >Aceptar
                    </div>
                </div> */}
            </div>
        )
    }

    const renderTemplate = () => {
        if (viewNewCode) return renderNewCode();
        if (isSucessful) return renderFirmaCorrecta();
        return (
            <>
                {errorCode && renderErrorCodeBanner()}
                {renderInputEnterCode()}
            </>
        );
    }

    return (
            <Modal
                        className="modal-otp"
                        {...props}
                        onHide={resetCode}
                        size="xl"
                        aria-labelledby="contained-modal-title-center"
                        centered
                        backdrop="static"
                    >
                        <Modal.Header >
                        </Modal.Header>
                        <Modal.Body>
                            {renderTemplate()}
                        </Modal.Body>
                    </Modal>
    )
}